import { MeshPhongMaterial, TextureLoader } from 'three'
import getGLTFModels from './getGLTFModels'

async function getModels(globeMaterials) {
    const materials = []

    globeMaterials.forEach((m, i) => {
        // Indexing from 0 changes to indexing from 1.
        materials[i + 1] = m
    })

    return getGLTFModels(materials)
}

export default async function getMapMaterials(anisotropy, normalScale, { onBeforeLoad, onModelsLoaded }) {
    const globeMaterials = [
        new MeshPhongMaterial({
            normalScale,
        }),
        new MeshPhongMaterial({
            normalScale,
        }),
        new MeshPhongMaterial({
            normalScale,
        }),
        new MeshPhongMaterial({
            normalScale,
        }),
    ]

    if (typeof onBeforeLoad === 'function') {
        onBeforeLoad(globeMaterials)
    }

    try {
        await Promise.all(
            globeMaterials.map((material, i) => new Promise((resolve, reject) => {
                // eslint-disable-next-line no-param-reassign
                material.map = new TextureLoader().load(`/resources/models/globe_texture_color${i + 1}.jpg`, (texture) => {
                    texture.flipY = false // eslint-disable-line no-param-reassign
                    texture.anisotropy = anisotropy // eslint-disable-line no-param-reassign
                    resolve(material)
                }, null, reject)
            })),
        )
    } catch (e) {
        console.error('Failed to load the map', e)
    }

    // We don't want this to block, thus `then` instead of `await`.
    getModels(globeMaterials)
        .then(onModelsLoaded)
        .catch((e) => {
            console.error('Failed to load models', e)
        })

    try {
        await Promise.all(
            globeMaterials.map((material, i) => new Promise((resolve, reject) => {
                // eslint-disable-next-line no-param-reassign
                material.normalMap = new TextureLoader().load(`/resources/models/earth_normal_${i + 1}.jpg`, (texture) => {
                    texture.flipY = false // eslint-disable-line no-param-reassign
                    texture.anisotropy = anisotropy // eslint-disable-line no-param-reassign
                    resolve(material)
                }, null, reject)
            })),
        )
    } catch (e) {
        console.error('Failed to load the normal map', e)
    }

    return globeMaterials
}
